import React, { useState } from 'react'
import { Menu, Milk, X } from 'lucide-react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const scrollToSection = (sectionId: string) => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
        setIsMenuOpen(false);
    };
    return (
        <nav className="fixed top-0 w-full bg-white/95 backdrop-blur-sm border-b border-gray-200 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-16">
                    <div className="flex items-center space-x-2">
                        <img src='./logo.png' className="h-8 w-8 text-[#002047]" />
                        <span className="text-xl font-bold text-[#002047]">Smart Dairy</span>
                    </div>

                    <div className="hidden md:flex space-x-8">
                        <button onClick={() => scrollToSection('hero')} className="text-gray-700 hover:text-[#002047] transition-colors">Home</button>
                        <button onClick={() => scrollToSection('about')} className="text-gray-700 hover:text-[#002047] transition-colors">About</button>
                        <button onClick={() => scrollToSection('reviews')} className="text-gray-700 hover:text-[#002047] transition-colors">Reviews</button>
                        <button onClick={() => scrollToSection('download')} className="text-gray-700 hover:text-[#002047] transition-colors">Download</button>
                        <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-[#002047] transition-colors">Contact</button>
                        <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-[#002047] transition-colors">FAQ</button>
                    </div>

                    <button
                        onClick={() => setIsMenuOpen(!isMenuOpen)}
                        className="md:hidden p-2 rounded-md text-[#002047] hover:bg-gray-100"
                    >
                        {isMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
                    </button>
                </div>

                {/* Mobile menu */}
                {isMenuOpen && (
                    <div className="md:hidden absolute top-16 left-0 right-0 bg-white border-b border-gray-200 shadow-lg">
                        <div className="flex flex-col space-y-4 p-4">
                            <button onClick={() => scrollToSection('hero')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">Home</button>
                            <button onClick={() => scrollToSection('about')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">About</button>
                            <button onClick={() => scrollToSection('reviews')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">Reviews</button>
                            <button onClick={() => scrollToSection('download')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">Download</button>
                            <button onClick={() => scrollToSection('contact')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">Contact</button>
                            <button onClick={() => scrollToSection('faq')} className="text-left text-gray-700 hover:text-[#002047] transition-colors">FAQ</button>
                        </div>
                    </div>
                )}
            </div>
        </nav>
    )
}

export default Header
